import { FC } from "react";

import { MotionImage, TransitionImageProps } from ".";

import { Variants } from "framer-motion";

export const FadeTransitionImage: FC<TransitionImageProps> = props => {
  const variants: Variants = {
    initial: { opacity: 0, scale: 0.75, translateY: "25%", transformOrigin: "bottom center" },
    animate: { opacity: 1, scale: 1, translateY: 0 },
    exit: { opacity: 0 },
  };

  return (
    <MotionImage variants={variants} initial="initial" animate="animate" exit="exit" {...props} />
  );
};
